/**
 * Normaliza listas API típicas: `data` como array o envoltorio con `items` / `results`.
 */
export function listFromApiResponse(list) {
	if (!list || typeof list !== "object") return [];
	const raw = list.data !== undefined ? list.data : list;
	if (Array.isArray(raw)) return raw;
	if (raw && Array.isArray(raw.items)) return raw.items;
	if (raw && Array.isArray(raw.results)) return raw.results;
	return [];
}

/** @deprecated usar listFromApiResponse */
export const functionsListFromResponse = listFromApiResponse;
